import { connect } from "react-redux";
import React, {useState} from "react";
import { companyComplainsTableHead } from "../../../app/config";
import { CompanyComplainsTableFilter, ComplainsTableRow, TableHeader, TablePagination } from "../../table";
import { Table, TableBody, TableContainer } from "@mui/material";
import _ from "lodash";
import { useTranslation } from "react-i18next";
import useComplaints from "../../../hooks/useComplaints";
import {next} from "lodash/seq";

function CompanyComplainsList({ companyId }) {
    const [open, setOpen] = React.useState(null);
    const { t } = useTranslation('CompanyComplainsList');

    const {data: complains, previousPage, nextPage, setFilter, filter, pagination, loading, error, refresh} = useComplaints({companyId: companyId});
    const [selectedItems, setSelectedItems] = useState([]);

    const handleRequestSort = (event, property) => {
        const direction =
            filter.orderBy === property &&
            filter.orderDirection === "asc"
                ? "desc"
                : "asc";
        setFilter("orderBy", property);
        setFilter("orderDirection", direction);
    }

    const onRowCheck = (complaint, isChecked) => {
        let selectedComplaints = [...selectedItems];

        if (!isChecked) {
            const alreadySelected = selectedComplaints.some(item => item.id === complaint.id);
            if (!alreadySelected) {
                selectedComplaints.push(complaint);
            }
        } else {
            const index = selectedComplaints.findIndex(item => item.id === complaint.id);
            if (index !== -1) {
                selectedComplaints.splice(index, 1);
            }
        }

        setSelectedItems(selectedComplaints);
    };

    const handleSelectAll = () => {
        if(selectedItems.length === complains.length) {
            setSelectedItems([]);
        } else {
            setSelectedItems(complains);
        }
    }
    
    const handleRowClick = (id) => setOpen(open ? null : id);

    return (
        <div className="fk-company-complains-list">
            <CompanyComplainsTableFilter hideTitle hideSearch companyId={companyId} listTitle={t('title')}/>
            <TableContainer>
                <Table size="medium" className="fk-table">
                    <TableHeader
                        crud
                        withCheckbox
                        items={companyComplainsTableHead}
                        orderBy={filter.orderBy}
                        order={filter.orderDirection}
                        numSelected={selectedItems.length}
                        rowCount={complains.length}
                        onRequestSort={handleRequestSort}
                        onSelectAllClick={handleSelectAll}
                        screen="ComplainsScreen"
                    />
                    <TableBody>
                    {complains?.map((complain) => {
                        const isChecked = _.some(selectedItems, (item) => item.id === complain.id);

                        return (
                            <ComplainsTableRow
                                key={complain.id}
                                checked={isChecked}
                                open={open === complain.id}
                                complain={complain}
                                columns={companyComplainsTableHead}
                                onCheck={() => onRowCheck(complain, isChecked)}
                                onRowClick={handleRowClick}
                            />
                        )
                    })}
                    </TableBody>
                </Table>
                {complains.length === 0 &&
                    <p className="fk-no-items">
                        {t('noRecords')}
                    </p>
                }
            </TableContainer>
            <TablePagination
                filter={filter}
                handlePreviousPage={nextPage}
                handleNextPage={previousPage}
            />
        </div>
    );
}

const mapStateToProps = (state) => ({
});

const actions = {
};

export default connect(mapStateToProps, actions)(CompanyComplainsList);